import { useState } from 'react'
import dayjs from 'dayjs'
import { DatePicker ,Row,Col} from 'antd'
import StatCounters from './components/StatCounters'
import QuickActions from './components/QuickActions'
import BarChartWidget from './components/BarChartWidget'
import RecentlyAdded from './components/RecentlyAdded'
import ActionCenter from './components/ActionCenter'
import SubscriptionPlans from './components/SubscriptionPlans'
import RecentTransactions from './components/RecentTransactions'
import TopPerformingDaycares from './components/TopPerformingDaycares'

const periods = ['Month', 'Year']
const now = dayjs()

function DashboardAnalytics() {
    const [period, setPeriod] = useState('Month')
    const [selected, setSelected] = useState(now)

    const month = period === 'Month' ? selected.month() + 1 : undefined
    const year = selected.year()

    return (
        <div style={{ minHeight: '100vh' }}>
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
                <div>
                    <h1 style={{ fontSize: 24, fontWeight: 800, color: '#111', margin: 0 }}>Platform Overview</h1>
                    <p style={{ fontSize: 13, color: '#888', margin: '4px 0 0' }}>Here's what's happening across your CubCare platform.</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ display: 'flex', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                        {periods.map(p => (
                            <button key={p} onClick={() => setPeriod(p)} style={{ border: 'none', cursor: 'pointer', padding: '7px 18px', fontSize: 13, fontWeight: 600, background: period === p ? '#111' : '#fff', color: period === p ? '#fff' : '#555' }}>
                                {p}
                            </button>
                        ))}
                    </div>
                    <DatePicker
                        picker={period === 'Month' ? 'month' : 'year'}
                        value={selected}
                        onChange={(val) => val && setSelected(val)}
                        allowClear={false}
                        style={{ borderRadius: 8, fontWeight: 600, fontSize: 13 }}
                    />
                </div>
            </div>

            {/* Quick Actions */}
            <QuickActions />

            {/* Stat Counters */}
            <StatCounters month={month} year={year} />

            {/* Revenue Chart + Recently Added */}

            {/* Action Center */}
            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col xs={24} lg={16}>
                    <BarChartWidget month={month} year={year} />
                </Col>
                <Col xs={24} lg={8}>
                    <RecentlyAdded month={month} year={year} />
                </Col>
            </Row>

            <ActionCenter month={month} year={year} />

            {/* Subscription Plans */}
            <SubscriptionPlans month={month} year={year} />
            <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                <Col xs={24} lg={16}>
                    <RecentTransactions month={month} year={year} />
                </Col>
                <Col xs={24} lg={8}>
                    <TopPerformingDaycares month={month} year={year} />
                </Col>
            </Row>
        </div>
    )
}

export default DashboardAnalytics
